export const FRONTENDS_PAGE = '/frontends';
export const LAUNCHING_SOON_PAGE = '/launching-soon';
export const SUCCESS_PAGE = '/success';
export const THANK_YOU_SCREEN_PAGE = '/thank-you-screen';
export const CANCEL_SCREEN_PAGE = '/cancel-screen';
export const CONNECT_ERROR_PAGE = '/connect-error';
export const NOT_FOUND_PAGE = '/';
export const UNSUPPORTED_BROWSER_PAGE = '/unsupported-browser';
export const EXCEED_RATE_LIMIT_PAGE = '/exceed-rate-limit';
